import styled from 'styled-components';

export const DatePickerStyled = styled.div`
  display: inline-block;
`;

export const FilterWrapperStyled = styled.div`
  outline: 15px solid ${({ theme }) => theme.colors.gray[3]};
  box-shadow: 0 0 6px 0 ${({ theme }) => theme.colors.gray[3]};
  border-radius: 12px;
  margin: 16px 0;
`;

export const TableWrapperStyled = styled.div`
  padding-bottom: 64px;
`;
